import {
  Body,
  VButton,
  VDropdownMenu,
  VDropdownMenuContent,
  VDropdownMenuItem,
  VDropdownMenuTrigger,
  cn,
} from '@vrzl/ui';
import { ChevronDown } from 'lucide-react';
import { useId } from 'react';

import type { OverviewBlockWidth } from '../api/types';
import { BLOCK_WIDTHS, blockWidthBarClass, blockWidthLabels } from '../constants';

function WidthBar({ width }: { width: OverviewBlockWidth }) {
  return (
    <span aria-hidden className="flex h-1.5 w-8 shrink-0 overflow-hidden rounded-full bg-muted">
      <span className={cn('h-full rounded-full bg-muted-foreground', blockWidthBarClass[width])} />
    </span>
  );
}

type WidthMenuProps = {
  value: OverviewBlockWidth;
  onChange: (width: OverviewBlockWidth) => void;
};

/** Keuzelijst Kwart / Half / Volledig met bestaande onderdelen (geen rauwe <select>). */
export function WidthMenu({ value, onChange }: WidthMenuProps) {
  const labelId = useId();

  return (
    <div className="flex flex-col gap-1.5">
      <Body as="span" id={labelId} weight="medium">
        Breedte
      </Body>
      <VDropdownMenu>
        <VDropdownMenuTrigger asChild>
          <VButton
            type="button"
            variant="outline"
            aria-labelledby={labelId}
            aria-describedby={`${labelId}-value`}
            className="w-full justify-between"
          >
            <span id={`${labelId}-value`} className="flex items-center gap-2">
              <WidthBar width={value} />
              {blockWidthLabels[value]}
            </span>
            <ChevronDown className="size-4 text-muted-foreground" aria-hidden />
          </VButton>
        </VDropdownMenuTrigger>
        <VDropdownMenuContent align="start">
          {BLOCK_WIDTHS.map((width) => (
            <VDropdownMenuItem key={width} onSelect={() => onChange(width)}>
              <WidthBar width={width} />
              {blockWidthLabels[width]}
            </VDropdownMenuItem>
          ))}
        </VDropdownMenuContent>
      </VDropdownMenu>
    </div>
  );
}
